import React from 'react';
import { Resource } from '../../../resource';
import { AppTool } from '../../../tool';
import './shareButton.scss';
import TooltipV2 from '../../tooltipV2/tooltipV2';

const ICON_SHARE =
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92S19.61 16.08 18 16.08z" />
  </svg>

function ShareButton({ url, hiddenText }) {
  const handleSave = (e) => {
    e.stopPropagation();
    AppTool.share(url)
  }

  return (
    <TooltipV2 description={Resource.common.share} anchor='top'>
      <div className='shareButtonCpn'>
        <div className='circleBtn' onClick={handleSave}>
          {ICON_SHARE}
        </div>
        {
          !hiddenText &&
          <div className='caption'>{Resource.common.share}</div>
        }
      </div>
    </TooltipV2>
  )
}

ShareButton.propTypes = {
  //
};

export default ShareButton;
